module.exports = __webpack_public_path__ + "6ac7942c19575985e1cede88d4e3fabc.pdf";